export default __webpack_public_path__ + "static/media/ruppe_icon.fdd80335.svg";